
export class NewUser {
  public login = '';
  public password = '';
  public firstName = '';
  public lastName = '';
  public email = '';
  public isPortal = false;
  public isMobile = false;
  public roleId = 0;
  public apps: number[];
  //public apps = {}; //: Map<number, number>;
  constructor() {}
}

export class User {
  public id = 0;
  public login = '';
  public firstName = '';
  public lastName = '';
  public email = '';
  public roles = '';
  public password = '';
  constructor() {}
}
